import { ViteReactSSG } from 'vite-react-ssg';
import { routes } from './App';
import { scheduleUpdateChecksAfterLoad } from './lib/swUpdate';
import './styles/globals.css';

// Register the service worker through the virtual module instead of the
// plugin-injected script. Guarded — this entry also runs during SSG
// prerendering in Node.
//
// Registration is `prompt`, not `autoUpdate`, and deliberately shows no
// prompt: `autoUpdate` reloads the open page when a new worker activates,
// potentially mid-form, and this does not.
//
// It does NOT mean the new build waits. Waiting was the bug: nothing called
// skipWaiting, so the browser only promoted a downloaded build once the last
// tab under the old worker went away, which on a phone can be weeks — and
// since navigations to `/` are answered from the precache, the homepage stayed
// pinned to whatever build first installed. The worker now takes over
// immediately (workbox skipWaiting + clientsClaim in vite.config.ts) while the
// open page carries on with the build it started with.
//
// The update *check* is scheduled on idle rather than on a wall-clock
// interval; see lib/swUpdate.
if (typeof window !== 'undefined') {
  import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({
      immediate: true,
      onRegisteredSW(_url, registration) {
        if (registration) scheduleUpdateChecksAfterLoad(registration);
      },
    });
  });
}

// vite-react-ssg reads `includedRoutes` as a named export of this server entry
// (it takes precedence over any ssgOptions.includedRoutes in vite config).
// Only public routes are prerendered; everything else falls back to the SPA shell.
export { includedRoutes } from './App';

export const createRoot = ViteReactSSG({ routes });
